import { render, staticRenderFns } from "./ActionCenter.vue?vue&type=template&id=2644ed6a"
import script from "./ActionCenter.vue?vue&type=script&lang=js"
export * from "./ActionCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports